@if (visible) {
    <div class="icn-popup" [@slideIn] (click)="onView()">

        <div class="icn-header">
            <div class="icn-brand">
                <div class="icn-avatar">
                    @if (message?.senderImage) {
                        <img [src]="message.senderImage" [alt]="message?.senderName" />
                    } @else {
                        {{ getInitials(message?.senderName) }}
                    }
                </div>
                <div class="icn-meta">
                    <span class="icn-name">{{ message?.senderName || 'Internal Chat' }}</span>
                    <span class="icn-time">{{ time }}</span>
                </div>
            </div>
            <button class="icn-close" (click)="onDismiss($event)" matTooltip="Dismiss">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="icn-body">
            @if (message?.type === 'image') {
                <span class="icn-content"><mat-icon class="icn-type-icon">image</mat-icon> Photo</span>
            } @else if (message?.type === 'video') {
                <span class="icn-content"><mat-icon class="icn-type-icon">videocam</mat-icon> Video</span>
            } @else if (message?.type === 'audio') {
                <span class="icn-content"><mat-icon class="icn-type-icon">mic</mat-icon> Audio</span>
            } @else if (message?.type === 'document') {
                <span class="icn-content"><mat-icon class="icn-type-icon">insert_drive_file</mat-icon> {{ message?.fileName || 'Document' }}</span>
            } @else if (message?.type === 'media_group') {
                <span class="icn-content"><mat-icon class="icn-type-icon">collections</mat-icon> {{ message?.media?.length || '' }} Photos</span>
            } @else if (message?.type === 'sticker') {
                <span class="icn-content"><mat-icon class="icn-type-icon">emoji_emotions</mat-icon> Sticker</span>
            } @else {
                <span class="icn-content">{{ message?.content | slice:0:80 }}</span>
            }
        </div>

        <div class="icn-footer">
            <button class="icn-btn-view" (click)="onView()">View Details</button>
            <button class="icn-btn-dismiss" (click)="onDismiss($event)">Dismiss</button>
        </div>

    </div>
}